module.exports = __webpack_public_path__ + "static/media/241-st-vincent-and-the-grenadines.dcfd358b.svg";